var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58716 2.48624C5.66543 2.48624 2.48624 5.66543 2.48624 9.58716C2.48624 13.5089 5.66543 16.6881 9.58716 16.6881C13.5089 16.6881 16.6881 13.5089 16.6881 9.58716C16.6881 5.66543 13.5089 2.48624 9.58716 2.48624ZM1 9.58716C1 4.8446 4.8446 1 9.58716 1C14.3297 1 18.1743 4.8446 18.1743 9.58716C18.1743 11.6909 17.4178 13.6179 16.162 15.1111L18.7823 17.7314C19.0726 18.0216 19.0726 18.4921 18.7823 18.7823C18.4921 19.0726 18.0216 19.0726 17.7314 18.7823L15.1111 16.162C13.6179 17.4178 11.6909 18.1743 9.58716 18.1743C4.8446 18.1743 1 14.3297 1 9.58716Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3d3a81ae80a7fca1138a3302662951b7.svg";
export { ForwardRef as ReactComponent };